/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetKycStatusResponse,
  SubmitKycResponse,
  SubmitKycRequest,
  GetAllKYCLevelsResponse
} from './schema'



export const utxKycGetKycStatus = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetKycStatusResponse>> => {
    return axios.get(
      `/kyc`,options
    );
  }


export const getUtxKycGetKycStatusQueryKey = () => [`/kyc`];

    
export type UtxKycGetKycStatusQueryResult = NonNullable<Awaited<ReturnType<typeof utxKycGetKycStatus>>>
export type UtxKycGetKycStatusQueryError = AxiosError<unknown>

export const useUtxKycGetKycStatus = <TData = Awaited<ReturnType<typeof utxKycGetKycStatus>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxKycGetKycStatus>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxKycGetKycStatusQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxKycGetKycStatus>>> = ({ signal }) => utxKycGetKycStatus({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxKycGetKycStatus>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxKycPostKycApplication = (
    submitKycRequest: SubmitKycRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SubmitKycResponse>> => {
    return axios.post(
      `/kyc/submit`,
      submitKycRequest,options
    );
  }



    export type UtxKycPostKycApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof utxKycPostKycApplication>>>
    export type UtxKycPostKycApplicationMutationBody = SubmitKycRequest
    export type UtxKycPostKycApplicationMutationError = AxiosError<unknown>

    export const useUtxKycPostKycApplication = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxKycPostKycApplication>>, TError,{data: SubmitKycRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxKycPostKycApplication>>, {data: SubmitKycRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxKycPostKycApplication(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxKycPostKycApplication>>, TError, {data: SubmitKycRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxKycGetAllKYCLevels = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAllKYCLevelsResponse>> => {
    return axios.get(
      `/kyc/all`,options
    );
  }


export const getUtxKycGetAllKYCLevelsQueryKey = () => [`/kyc/all`];

    
export type UtxKycGetAllKYCLevelsQueryResult = NonNullable<Awaited<ReturnType<typeof utxKycGetAllKYCLevels>>>
export type UtxKycGetAllKYCLevelsQueryError = AxiosError<unknown>

export const useUtxKycGetAllKYCLevels = <TData = Awaited<ReturnType<typeof utxKycGetAllKYCLevels>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxKycGetAllKYCLevels>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxKycGetAllKYCLevelsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxKycGetAllKYCLevels>>> = ({ signal }) => utxKycGetAllKYCLevels({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxKycGetAllKYCLevels>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxKycUploadDocument = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/kyc/upload`,undefined,options
    );
  }



    export type UtxKycUploadDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof utxKycUploadDocument>>>
    
    export type UtxKycUploadDocumentMutationError = AxiosError<unknown>

    export const useUtxKycUploadDocument = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxKycUploadDocument>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxKycUploadDocument>>, TVariables> = () => {
          

          return  utxKycUploadDocument(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxKycUploadDocument>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    